var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.file.categoria
          ? "Participantes del Expediente # " +
            _vm.file.categoria +
            "-" +
            _vm.file.numeroExt
          : "Participantes del Expediente " + _vm.file.numero,
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "vs-list",
        { staticClass: "box-participants" },
        _vm._l(_vm.participants, function(subject, index) {
          return _c(
            "div",
            { key: index },
            [
              subject.tipoDestino === "1"
                ? _c(
                    "vs-list-item",
                    {
                      staticStyle: {
                        "border-bottom": "1px solid #cdcdcd",
                        "padding-bottom": "12px"
                      },
                      attrs: {
                        icon: "contact_mail",
                        title: subject.destinoListaNombre,
                        subtitle: subject.destinoNombre
                      }
                    },
                    [
                      subject.tipoDestino === "1"
                        ? _c("vs-chip", { attrs: { color: "primary" } }, [
                            _vm._v(" Destinatario ")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              subject.tipoDestino === "2"
                ? _c(
                    "vs-list-item",
                    {
                      staticStyle: {
                        "border-bottom": "1px solid #cdcdcd",
                        "padding-bottom": "12px"
                      },
                      attrs: {
                        icon: "supervised_user_circle",
                        title: subject.destinoListaNombre,
                        subtitle: subject.destinoNombre
                      }
                    },
                    [
                      subject.tipoDestino === "2"
                        ? _c("vs-chip", { attrs: { color: "#43C3B9" } }, [
                            _vm._v(" En copia ")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }